import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { TextInput as Text } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import { useFootnoteDisplayStore } from "../../../../../../stores/use-footnotedisplay-store";
import { Select } from "@caelor/ui";

const SelectOptions = [
  { label: "Heading 1", value: "1" },
  { label: "Heading 2", value: "2" },
  { label: "Heading 3", value: "3" },
  { label: "Heading 4", value: "4" },
  { label: "Heading 5", value: "5" },
  { label: "Heading 6", value: "6" },
];

function FootnoteDisplaySettings() {
  const { t } = useTranslation();

  const { data, setData } = useFootnoteDisplayStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("content")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("title")}</OptionLabel>
          <OptionContent>
            <Text
              placeholder={t("add")}
              value={data.title}
              onChange={(value) => setData({ title: value })}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("title-style")}</OptionLabel>
          <OptionContent>
            <Select
              placeholder={t("add")}
              value={SelectOptions.find((op) => op.value === data.titleStyle)}
              options={SelectOptions}
              onChange={(option) => setData({ titleStyle: option.value })}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default FootnoteDisplaySettings;
